import GLmol from './b_GLmol_modified'
import PropTypes from 'prop-types'
import React from 'react'

class SaxsAbInitioPDBViewer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      PDBViewerDivHeight: 300,
      isPDBViewerDivHeightUpdated: false,
      isGLViewerInstanceCreated: false,
    }

    this.isWebGLEnabled = this.isWebGLEnabled.bind(this)

    this.isWebGLEnabled = this.isWebGLEnabled()
  }

  render() {
    return (
      <div>
        <textarea
          id="divToRenderPDB_pdb_src"
          style={{ width: '300px', height: '300px', display: 'none' }}
          value={this.props.data}
          readOnly
        />
        <div id="divToRenderPDB_pdb" style={{ height: this.state.PDBViewerDivHeight, backgroundColor: 'black' }}>
          {this.isWebGLEnabled === false ? <span style={{ color: 'white' }}> WebGL is not enabled </span> : null}
        </div>
      </div>
    )
  }

  componentDidMount() {
    if (this.isWebGLEnabled === true) {
      if (this.state.isGLViewerInstanceCreated === false) {
        this.GLmol = new GLmol('divToRenderPDB_pdb')
        this.setState({ isGLViewerInstanceCreated: true })
      }
    }

    if (this.props.data) {
      this.GLmol.loadMolecule()
    }
  }

  componentDidUpdate() {
    if (this.isWebGLEnabled === true) {
      if (this.state.isGLViewerInstanceCreated === false) {
        if (this.state.isPDBViewerDivHeightUpdated === true) {
          this.GLmol = new GLmol('divToRenderPDB_pdb')
          this.setState({ isGLViewerInstanceCreated: true })
        }
      }

      if (this.props.data) {
        this.GLmol.loadMolecule()
      }
    }
  }

  isWebGLEnabled(return_context) {
    if (window.WebGLRenderingContext) {
      const canvas = document.createElement('canvas')
      const names = ['webgl', 'experimental-webgl', 'moz-webgl', 'webkit-3d']
      let context = false
      for (let i = 0; i < 4; i++) {
        try {
          context = canvas.getContext(names[i])
          if (context && typeof context.getParameter === 'function') {
            if (return_context) {
              return {
                name: names[i],
                gl: context,
              }
            }
            return true
          }
        } catch (e) {
          alert('Erreur : ', e) // eslint-disable-line no-alert
        }
      }
      return false
    }
    return false
  }
}

export default SaxsAbInitioPDBViewer

SaxsAbInitioPDBViewer.propTypes = {
  data: PropTypes.string,
}
